import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Headers, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';

export interface Person {
    id: string;
    isActive: boolean;
    age: number;
    name: string;
    gender: string;
    company: string;
    email: string;
    phone: string;
}

@Injectable()
export class CrudService {
    photos = [];
    province: any[];
    items: any[];
    urlApi = 'https://carbooking.snru.ac.th/back_end/data_manage_carbooking.php';
    constructor(private http: Http, private httpc: HttpClient) { }
    //******* Implement your APIs ********
    getData(para: any = {}) {
        return this.http.get(this.urlApi, { params: para })
            .map((res: Response) => res.json())
    }
    getCar(car_license: string,car_driver_1:string,car_driver_2:string): Observable<any> {
        var dv1 = (car_driver_1==null||parseInt(car_driver_1)>0)?'xxx':car_driver_1;
        var dv2 = (car_driver_2==null||parseInt(car_driver_2)>0)?'xxx':car_driver_2;
        const param = { 'Cmd': "Get_car_data", 'car_license': car_license,'car_driver_1':dv1,'car_driver_2':dv2};
        return this.getData(param);
    }
    getBookingUser(): Observable<any> {
        const param = { 'Cmd': "Get_user_booking" };
        return this.getData(param);
    }
    getCarsReportAdmin(dt_start: string, dt_end: string): Observable<any> {
        const param = { 'Cmd': "Get_report_cars_admin", 'datetime_start': dt_start,'datetime_end': dt_end  };
        return this.getData(param);
    }
    getCarsReport(): Observable<any> {
        const param = { 'Cmd': "Get_report_cars" };
        return this.getData(param);
    }
    getDriverReportAdmin(dt_start: string, dt_end: string): Observable<any> {
        const param = { 'Cmd': "Get_report_car_driver_admin", 'datetime_start': dt_start,'datetime_end': dt_end };
        return this.getData(param);
    }
    getDriverReport(): Observable<any> {
        const param = { 'Cmd': "Get_report_car_driver" };
        return this.getData(param);
    }
    getUserData(): Observable<any> {
        const param = { 'Cmd': "Get_user_data"};
        return this.getData(param);
    }   
    searchCarBooking(dt_start: string, dt_end: string): Observable<any> {
        const param = { 'Cmd': "Search_car_booking", 'datetime_start': dt_start,'datetime_end': dt_end };
        return this.getData(param);
    }
    searchBookingAdmin(dt_start: string, dt_end: string): Observable<any> {
        const param = { 'Cmd': "Search_car_booking_admin", 'datetime_start': dt_start,'datetime_end': dt_end };
        return this.getData(param);
    }
    searchBookingAdmin1(dt_start: string, dt_end: string): Observable<any> {
        const param = { 'Cmd': "Search_car_booking_admin", 'datetime_start': dt_start,'datetime_end': dt_end, 'booking_status': "0" };
        return this.getData(param);
    }
    searchBookingAdmin2(dt_start: string, dt_end: string,bk_status:string): Observable<any> {
        const param = { 'Cmd': "Search_car_booking_admin", 'datetime_start': dt_start,'datetime_end': dt_end, 'booking_status': bk_status };
        console.log(param);
        return this.getData(param);
    }
    searchBooking(dt_start: string, dt_end: string): Observable<any> {
        const param = { 'Cmd': "Search_car_booking_list", 'datetime_start': dt_start,'datetime_end': dt_end };
        return this.getData(param);
    }  
    searchBooking_calendar(dt_start: string, dt_end: string): Observable<any> {
        const param = { 'Cmd': "Search_car_booking_calendar_list", 'datetime_start': dt_start,'datetime_end': dt_end };
        return this.getData(param);
    }  
    getBookingForType(): Observable<any> {
        const param = { 'Cmd': "Get_booking_for_type" };
        return this.getData(param);
    }  
    getBookingDep(cid: string): Observable<any> {
        const param = { 'Cmd': "Get_department", 'citizen_id': cid };
        return this.getData(param);
    }
    getProvince(): Observable<any> {
        const param = { 'Cmd': "Get_province" };
        return this.getData(param);
    }
    getDistic(province_id): Observable<any> {
        const param = { 'Cmd': "Get_distic",'province_id':province_id };
        return this.getData(param);
    }
    getSubDistic(distic_id): Observable<any> {
        const param = { 'Cmd': "Get_sub_distic",'distic_id':distic_id};
        return this.getData(param);
    }
    getDepartment(citizen_id : string): Observable<any> {
        const param = { 'Cmd': "Get_department_data",'citizen_id':citizen_id };
        return this.getData(param);
    } 
    getCars(): Observable<any> {
        const param = { 'Cmd': "Get_car_detail_data"};
        return this.getData(param);
    } 
    getCarDriver(): Observable<any> {
        const param = { 'Cmd': "Get_car_driver_data"};
        return this.getData(param);
    }   
    DeleteCarBooking(param) {
        return this.http.post(this.urlApi, param).map((res: Response) => res.json());
    }
    UpdateDriver(param) {
        return this.http.post(this.urlApi, param).map((res: Response) => res.json());
    }
    SaveCarBooking(param) {
        return this.http.post(this.urlApi, param).map((res: Response) => res.json());
    }
    HidAddress(address_id: string): Observable<any> {
        const param = { 'Cmd': "Hid_address",post_address_id: address_id};
        return this.http.get(this.urlApi, { params: param })
            .map((res: Response) => res.json())
    }
    UpdateBooking(datavalue: string, colum_name: string,  booking_id: string): Observable<any> {
        const param = { 'Cmd': "Update_booking_data", 'datavalue': datavalue, 'columname': colum_name,  'booking_id': booking_id };
        return this.http.post(this.urlApi, param).map((res: Response) => res.json());
    }
    UpdateBooking2(datavalue: string, colum_name: string,  booking_id: string, driver1:string, driver2:string): Observable<any> {
        const param = { 'Cmd': "Update_booking_data_admin", 'datavalue': datavalue, 'columname': colum_name,  'booking_id': booking_id,'car_driver':driver1,'car_driver2':driver2 };
        return this.http.post(this.urlApi, param).map((res: Response) => res.json());
    } 
    SendLineMessage(message:string, citizen_id:string)
    {
        console.log(citizen_id)
        var line_bot_url = "https://carbooking.snru.ac.th/webhook/bot/carbooking_line_bot.php";
        const param = {'message': message, 'citizen_id': citizen_id};
        return this.http.post(line_bot_url, param);
    }   
}



// WEBPACK FOOTER //
// D:/Programing/carbooking/src/app/views/crud.service.ts